<template>
    <el-dialog :data="products" title="选择产品" :before-close="handleDialogShow" :visible="dialogVisible" width="30%" center>
        <el-checkbox-group v-model="checkList" class="checkbox-mg30" >
            <el-checkbox  v-for="product in productList"
                :key="product.id"
                :value="product.id"
                :label="product.id">{{product.name}}
            </el-checkbox >
        </el-checkbox-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleDialogShow">取 消</el-button>
                <el-button @click="handleDialogShow" type="primary">确 定</el-button>
            </div>
    </el-dialog>
</template>
<script>
export default {
    props:{
            show:{
                type:Boolean,
                required:false,
            },
            productList:{
                type:Array,
                required:true
            },

            products:{
                type:Array,
                required:true
            },
            dialogVisible:{
                default:false
        }
    },
    computed: {
    　　check() {
    　　　　return this.products
    　　}
    },
    watch:{
        　　check(newValue, oldValue) {
                let arr= []
                if(this.products.length>0){
                    this.products.forEach(item=>{
                        arr.push(item.id);
                    });
                }
                this.checkList = arr;
        　　}
    },
    data(){
        
        return {
                checkList:[],
            }
    },
    methods:{
        handleDialogShow(){
            this.$emit('handleDialogShow',this.checkList);
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/productDialog.vue